// extracted by mini-css-extract-plugin
module.exports = {"body":"Wrapper_body__yUwgo","root":"Wrapper_root__2QrVK","flexbox":"Wrapper_flexbox__O_s2f","fadein":"Wrapper_fadein__1cJt2","searchBar":"Wrapper_searchBar__2ud3s"};